<template>
  <DBox
    :id="'cmp-contacts-group-related_contact'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="'Add Contact'"
    @addClick="addGroupContactClick"
  >
    <NTable
      class="dbox1"
      id="contacts-group-related_contact"
      :headers="headers"
      :items="contacts"
      :showNoItems="false"
      :config="invoiceTableConfig"
      @scrollnext="onGroupScroll"
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th
            v-for="(header, index) in headers"
            v-bind="thcon(header.value)"
            :key="header.value"
          >
            <div v-if="index !== headers.length - 1" class="header-name">
              {{ thtext(header.value) }}
            </div>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('name')" @click="onNameClick(item)">
            <span class="ut-link ut-text-accent5">{{ getName(item) }}</span>
          </td>
          <td v-bind="tdcon('city')">
            <span>{{ item["city"] }}</span>
          </td>
          <td v-bind="tdcon('notes')">
            <span>{{ item["notes"] }}</span>
          </td>
          <td v-bind="tdcon('mail')">
            <div v-if="item.email1" class="dt-icon-container">
              <img
                @click.stop="(e) => sendEmail(item)"
                src="static/icons/email/email-grey.svg"
                class="dt-icon v5 s2"
                alt="Mail"
                title="Mail"
              />
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => removeContact(item)"
                class="dt-icon v5 s2"
                alt="Delete"
                title="Delete"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>

    <!-- <div class="dbox-title-bar--options" v-if="showAddButton">
      <img @click="addGroupContactClick" src="static/icons/add-icon.svg" class="dt-icon v4" />
    </div> -->

    <v-dialog v-model="groupContactsAddModalFlag" persistent width="480">
      <GroupContactsAddModal
        :modal-data="groupContactsAddModalData"
        @cancelled="onGroupContactsAddModalCancelled"
        @done="updateContracts"
      />
    </v-dialog>
  </DBox>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import Dropdown from "../../../../plugins/dropdown/dropdown";
import { ContactGroupsService } from "../../services/contact_groups.service";
import GroupContactsAddModal from "./group-contacts-add-modal";
import { contactListLDTRoutes } from "../../router/routes";
import DBox from "@dtplugins/dbox/dbox";
import { Subject } from "rxjs";
import { subscribeSubject } from "../../../../utility";
import { ContactFuncs } from "../../models/contacts.model";
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    NTable,
    Dropdown,
    GroupContactsAddModal,
    DBox,
  },
  props: ["selectedContactGroup"],
  data: function () {
    return {
      invoiceTableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true,
      }),
      artistCalendarDateModalContainer: false,
      artistCalendarDateModal: false,
      contacts: [],
      showAddButton: false,
      groupContactsAddModalFlag: false,
      groupContactsAddModalData: {},
      scrollSubject$: new Subject(),
      currentRow: 100,
    };
  },
  mounted: function () {
    subscribeSubject(this, this.scrollSubject$, (scrollTop) => {
      this.nextScroll();
    });
  },
  watch: {
    selectedContactGroup: {
      immediate: true,
      handler: function (n, o) {
        if (n && n.contacts) {
          this.updateContracts(n.contacts);
          this.showAddButton =
            n.group &&
            (n.group.group_owner == n.user.user_id || n.group.private == "0");
        } else {
          this.contacts = [];
        }
      },
    },
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("name"),
        createTableHeader("city"),
        createTableHeader("notes"),
        createTableHeader("mail", { text: false, mw: 40 }),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GroupContactsData.SET.ALL]:
        ActionTypes.GroupContactsData.SET.ALL,
    }),
    nextScroll: async function () {
      const tableId =
        "group_contacts_table-" + this.selectedContactGroup.group.group_id;
      const contactArray = await ContactGroupsService.getContactGroupsPage(
        this.selectedContactGroup.group.group_id,
        tableId,
        this.currentRow
      );
      this.currentRow += 100;
      console.log("RRRRRRRR", contactArray);
      this.contacts.push(...contactArray.data.contacts);
      console.log("SCROLL", this.currentRow, contactArray);
    },
    onGroupScroll: async function () {
      //console.log("SCROLL");
      const tableId =
        "group_contacts_table-" + this.selectedContactGroup.group.group_id;
      const contactArray = await ContactGroupsService.getContactGroupsPage(
        this.selectedContactGroup.group.group_id,
        tableId,
        this.currentRow
      );
      this.currentRow += 100;
      //console.log("RRRRRRRR", contactArray);
      this.contacts.push(...contactArray.data.contacts);
      //console.log("SCROLL", this.currentRow, contactArray);
      // this.scrollSubject$.next();
    },

    onRelationTextBoxBlur: function (e, item) {},
    removeContact: async function (item) {
      const confirmationResult = await confirmDelete(
        "contact",
        item.name_computed
      );
      if (confirmationResult === "OK") {
        this.contacts = this.contacts.filter(
          (e) => e.contact_id != item.contact_id
        );
        ContactGroupsService.deleteGroupContact(item.contact_relation_id);
        this[ActionTypes.GroupContactsData.SET.ALL](this.contacts);
      }
    },
    addGroupContactClick() {
      this.groupContactsAddModalFlag = true;
      ContactGroupsService.getGroupContactModal(
        this.selectedContactGroup.group.group_id
      ).then((res) => {
        this.groupContactsAddModalData = res.data;
        // console.log(this.groupContactsAddModalData);
      });
    },
    onGroupContactsAddModalCancelled() {
      this.groupContactsAddModalFlag = false;
    },
    getName: ContactFuncs.getName,
    updateContracts(contacts) {
      console.log("RT", contacts);
      this.contacts = contacts.map((row) => {
        row.name_computed = row.company_name
          ? row.company_name || ""
          : (row.first_name || "") + " " + (row.last_name || "");
        return row;
      });
    },
    sendEmail(item) {
      window.location = `mailto:${item.email1}`;
    },
    onNameClick: function (item) {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: item.contact_id,
          tab: "overview",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.contacts-group-related_contact {
  //--ntable-height: 90px;
}
</style>
